"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var SubmissionThankYou = function SubmissionThankYou(props) {
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "clearer"
  }), /*#__PURE__*/_react["default"].createElement("h1", null, props.typeform === "" ? "Thank you for your submission!" : "Awesome!"), props.typeform === "" ? /*#__PURE__*/_react["default"].createElement("p", {
    "class": "align-center"
  }, "Someone will be in touch with you shortly if we're interested in your video.") : /*#__PURE__*/_react["default"].createElement("p", {
    "class": "align-center"
  }, "Thank you for your submission! Our team is checking out the video, and if the video is accepted, we will email you the next steps. In the meantime, complete this form:", " ", /*#__PURE__*/_react["default"].createElement("a", {
    href: props.typeform
  }, props.typeform), " with a few questions about the video."), /*#__PURE__*/_react["default"].createElement("div", {
    className: "clearer"
  }));
};
var _default = SubmissionThankYou;
exports["default"] = _default;